// extracted by mini-css-extract-plugin
export default {"headerContainer":"style_headerContainer__pljAH","header":"style_header__CzZjl","body":"style_body__gVeP9"};